<template>
    <div class="body">
            <el-input v-model="form.key" class="serch" placeholder="请输入内容"></el-input>
            <el-button type="primary" @click="serch">搜索</el-button>
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="tableHeaderColor" border  @selection-change="handleSelectionChange">
                <el-table-column type="selection"  width="55"></el-table-column>
                  <el-table-column  prop="id"  label="序号"  width="120"> </el-table-column>
                <el-table-column prop="username" label="姓名"></el-table-column>
                <el-table-column prop="phone" label="手机"></el-table-column>
                <el-table-column prop="gender" :formatter="gender" label="性别"  width="120" ></el-table-column>
                <el-table-column prop="birthdayDt" label="生日"  ></el-table-column>
                <el-table-column prop="addr" label="地址"  ></el-table-column>
                <el-table-column prop="address" label="操作">
                  <template slot-scope="scope">
                      <el-button type="primary" @click.native.prevent="couPons(scope.row)">查看优惠券</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="option">
                    <el-button type="primary" @click="openCard" :style="{'visibility':visibility}" >选择优惠券</el-button>
            </div>

            <!-- 我的优惠券 -->   
            <el-dialog title="选择优惠券" :visible.sync="dialogVisible"  width="80%" :before-close="handleClose">
                <el-row>
                    <el-col class="card" :span="11" v-for="(item,index) in list" :key="index" :offset="index > 0 ? 0 : 0" >
                            <el-card  class="cardEl" :class="{active:istrue==index}" >
                                <div class="coupon"  @click="check(index)">
                                        <div class="couponA">
                                            <p class="price">￥{{item.denomination}}</p>
                                            <!-- <p class="rule">满{{item.rule}}元可用</p> -->
                                        </div>
                                        <div class="couponB">
                                            <span>可使用</span>
                                            <p class="type">{{item.name}}</p>
                                            <p class="time" style=" display :inline-block ;width: 100%;overflow: hidden;textOverflow: ellipsis;whiteSpace: nowrap" :title=item.rule>{{item.rule}}</p>
                                            <!-- <hr class="hr"/>
                                            <p class="info">详细信息</p> -->
                                        </div>
                                </div>
                            </el-card>
                    </el-col>
                </el-row>  
                <br/>
                <br/>
                <span class="number">选择数量:</span>
                <el-input-number v-model="num" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number>
                <br/>
                <div class="block">
                    <span class="demonstration">默认</span>
                    <el-date-picker v-model="formCard.expireDt"  type="date"  placeholder="选择日期"> </el-date-picker>
                </div>                
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sendCard">确 定</el-button>
                </span>
            </el-dialog>

              <!-- 查看优惠券 -->
              <el-dialog title="我的优惠券" :visible.sync="card"  width="80%" :before-close="handleClose">
                <el-row>
                    <el-col class="card" :span="11" v-for="(item,index) in list" :key="index" :offset="index > 0 ? 0 : 0" >
                            <el-card  class="cardEl" :class="{active:istrue==index}" >
                                <div class="coupon"  @click="check(index)">
                                        <div class="couponA">
                                            <p class="price">￥{{item.denomination}}</p>
                                            <!-- <p class="rule">满{{item.rule}}元可用</p> -->
                                        </div>
                                        <div class="couponB">
                                            <span>可使用</span>
                                            <p class="type">{{item.name}}</p>
                                            <p class="time">{{item.expireDt}}</p>
                                            <p class="time" style=" display :inline-block ;width: 100%;overflow: hidden;textOverflow: ellipsis;whiteSpace: nowrap" :title=item.rule>{{item.rule}}</p>
                                            <!-- <hr class="hr"/>
                                            <p class="info">详细信息</p> -->
                                        </div>
                                </div>
                            </el-card>
                        </el-col>
                </el-row>
            </el-dialog>

    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('member')
export default {
    data(){
        return{
        num: 1,
        dialogVisible: false,
        card:false,
        form:{
           key:'',
        },
        visibility:'hidden',
        istrue:0,
        formCard:{
          userId:[],
          couponId:'',
          couponNumber:'',
          expireDt:'',
        },
        list:[
              {id:1,price:1000,rule:1500,type:'仅可酒店使用',time:'2020.08.22-2020.10.01',abso:'可使用'},
              {id:2,price:2000,rule:2300,type:'仅可跟团使用',time:'2020.08.22-2020.10.01',abso:'已过期'},
              {id:3,price:3000,rule:4000,type:'仅可民宿使用',time:'2020.08.22-2020.10.01',abso:'快到期'},
              {id:4,price:500,rule:900,type:'仅可商城使用',time:'2020.08.22-2020.10.01',abso:'可使用'},
              {id:5,price:800,rule:1200,type:'仅可机票使用',time:'2020.08.22-2020.10.01',abso:'可使用'},
        ],
        input: '',
        sex:'',
        tableData: [],
        multipleSelection: []
        }
    },
    methods: {
      ...mapMutations(['alterUserId']),
      //搜索
      serch(){
        this.joker.member.memberUser(this.form).then(res=>{
          console.log(res)
          this.tableData = res.content
        })
        this.visibility = 'visible'
      },
      //打开优惠券选择框
      openCard(){
        if(this.formCard.userId.length == 0){
            alert("请勾选收卡人名称")
        }else{
          this.dialogVisible = true
           //列表
          this.joker.member.memberList().then(res=>{
              console.log(res)
              this.list = res.content
          }).catch(res=>{
              console.log(res)
          })

        }

      },
      //选择优惠券
      check(index){
        this.istrue = index
      },
      //确认发卡
      sendCard(){
          this.formCard.couponId = this.list[this.istrue].id
          this.formCard.couponNumber = this.num
          this.dialogVisible = false
          console.log(this.formCard)
          this.joker.member.sendMember(this.formCard).then(res=>{
              console.log(res)
              alert("发放优惠券成功")
          })

      },
      //查看优惠券
      couPons(row){
         this.alterUserId(row.id)


         this.joker.member.searchUser(row.id).then(res=>{
              console.log(res)
              if(res.content.length == 0){
                  alert('暂无优惠券')
              }else{
                  this.list = res.content
                    this.card = true
              }
   
         })

      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      //多选按钮
      handleSelectionChange(val) {
        let that = this
        let ids = [];
        val.forEach(function(value){
          ids.push(value.id)
        })
        that.formCard.userId =ids.slice(-val.length)
        this.multipleSelection = val;
      },

      // 修改table header的背景色
      tableHeaderColor({ row, column, rowIndex, columnIndex }){
            if (rowIndex === 0) {
                return 'background-color: #409EFF;color: #fff'
            }
      },

      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      //发卡数量
      handleChange(value) {
        console.log(value);
        this.num = value
      },

       //是否高亮
      gender(row, column){
        if(row.gender==1){
           return '男'
        }else{
           return '女'
        }
      },

    }    
}
</script>

<style scoped>

.option{
    margin-top: 1%;
}

.card{
    margin-left: 3%;
    margin-top: 1%;
}

.cardEl{
    padding-bottom: 5%;
}

.price{
    color: #FFFFFF;
    font-size: 30px;
    margin-top: 5%;
    line-height: 90px;
}

.rule{
    color: #FFFFFF;
    font-size: 15px;
}

.hr{
    width: 80%;
    text-align:center;
    margin-left: 10%;
    border:1px dashed #696969;
}

.type{
    margin-top: 1%;
    height: 40%;
    font-size: 20px;
    font-weight: 700;
}

.time{
    height: 30%;
}

.info{
    margin-top: 1%;
}

.coupon{
  clear: both;
  padding-top: 1%;
}

.couponA{
      width: 110px;
      height: 100px;
      background: linear-gradient(0.25turn, #00c6ff, #0072ff), radial-gradient(circle at 11px 4px, transparent 6px, #0072ff 6px) top left, radial-gradient(circle at 10px 56px, transparent 6px, #0072ff 6px) bottom left, linear-gradient(0.25turn, #0072ff, #0072ff);
      background-repeat: no-repeat;
      background-size: 100px 100px, 15px 100px, 15px 100px, 50px 50px;
      background-position: 0px 0px,100px -4px, 100px 26px;
      border-radius:10px;
      float: left;
}

.couponB{
    float: left;
    background-color:#FFFFFF;
    height: 100px;
    width: 300px;
    border-radius:10px;
    border:1px dashed #696969;
    position:relative;
    overflow: hidden;
}

.couponB span{
    position: absolute;
    bottom:0;
    display: block;
    font-size:12px;
    color:#fff;
    background: #36A8FF;
    width:110px;
    height: 20px;
    text-align: center;
    transform: rotate(45deg);
    top:18px;
    right:-26px;
}

.check{
    margin-top: 5%;
}

.number{
    margin-top: 99%;
}

.serch{
  width: 30%;
  margin-top: 1%;
  margin-bottom: 1%;
}

.active {
    background-color: silver;
}

.block{
  margin-top: 2%;
}

</style>


// WEBPACK FOOTER //
// src/components/Member/SendCard.vue